import React from "react";
import { Phone, MapPin } from "lucide-react";
import { PHOTOS } from "@/assets/images";

const HERO_BG = PHOTOS.heroBW;

export default function Hero({ t }) {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${HERO_BG})`,
          backgroundPosition: "center 35%",
        }}
        aria-hidden="true"
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/80" />
      <div className="grain" />

      {/* Content */}
      <div className="relative z-10 mx-auto flex min-h-[100svh] max-w-7xl flex-col justify-between px-6 py-10 sm:px-10 lg:px-16">
        <div className="flex items-center justify-between">
          <span
            className="font-body text-xs uppercase tracking-[0.35em] text-[#EAE4D9]/80"
            data-testid="hero-eyebrow"
          >
            Est. Bergara
          </span>
        </div>

        <div className="max-w-4xl reveal">
          <p
            className="mb-6 font-body text-sm uppercase tracking-[0.4em] text-[#EAE4D9]"
            data-testid="hero-location"
          >
            {t.hero.tagline}
          </p>
          <h1
            data-testid="hero-title"
            className="font-serif-display text-[15vw] sm:text-7xl lg:text-[7.5rem] leading-[0.95] text-[#F5F2EB]"
          >
            Telleixako
            <span className="block italic font-light text-[#EAE4D9]">
              Benta
            </span>
          </h1>
          <p
            className="mt-8 max-w-xl font-body text-base leading-relaxed text-[#F5F2EB]/85 sm:text-lg"
            data-testid="hero-subtitle"
          >
            {t.hero.subtitle}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="tel:+34943291730"
              data-testid="hero-call-button"
              className="group inline-flex items-center gap-3 bg-[#F5F2EB] px-7 py-4 text-[#1A1A1A] transition-all duration-300 hover:bg-[#5C3A21] hover:text-[#F5F2EB]"
            >
              <Phone className="h-4 w-4" strokeWidth={1.5} />
              <span className="font-body text-sm uppercase tracking-[0.25em]">
                {t.hero.callBtn}
              </span>
            </a>
            <a
              href="#contact"
              data-testid="hero-map-button"
              className="group inline-flex items-center gap-3 border border-[#F5F2EB]/50 px-7 py-4 text-[#F5F2EB] transition-all duration-300 hover:border-[#F5F2EB] hover:bg-[#F5F2EB]/10"
            >
              <MapPin className="h-4 w-4" strokeWidth={1.5} />
              <span className="font-body text-sm uppercase tracking-[0.25em]">
                {t.hero.mapBtn}
              </span>
            </a>
          </div>
        </div>

        <div className="mt-12 flex items-end justify-between border-t border-[#F5F2EB]/20 pt-6">
          <div className="font-body text-xs uppercase tracking-[0.35em] text-[#EAE4D9]/70">
            Calle Telleria, 16 · Bergara
          </div>
          <a
            href="tel:+34943291730"
            className="font-serif-display text-lg italic text-[#EAE4D9] hover:text-white sm:text-xl"
            data-testid="hero-phone"
          >
            +34 943 29 17 30
          </a>
        </div>
      </div>
    </section>
  );
}
